<template>
  <div>
    <template v-if="profiles !== null && !busy">
      <div class="row menubar">
        <input
          type=text ref="search" placeholder="Zoeken"
          @keyup="updateSearch" class="searchbar" style="width: 100px"
        >
        <button
          :class="{ 'disabled': search == 'queued' }"
          @click="
            resultsPerPage=10;
            search='queued';
            currentPage=0;
            $refs.search.value = ''
          "
          style="float:right;"
        >
          Wachtrij {{
            sumBy(status, 'amount')
            - filter(profiles, (o) => { o.delta !== null }).length
          }} of {{sumBy(status, 'amount')}}
        </button>
        <button
          :class="{ 'disabled': search == 'notice' }"
          @click="
            search='notice';
            resultsPerPage=100000;
            currentPage = 0;
            $refs.search.value=''
          "
          style="float:right;">Verlies melding</button>
        <button
          :class="{ 'disabled': search == 'negative' }"
          @click="
            resultsPerPage=10;
            search='negative';
            currentPage = 0;
            $refs.search.value=''
          "
          style="float:right;">Verlies</button>
        <button
          :class="{ 'disabled': search == '' }"
          @click="
            resultsPerPage=10;
            search='';
            currentPage=0;
            $refs.search.value=''
          "
          style="float:right;"
        >
          Alles
        </button>

        <!-- brand sorting -->
        <div class="dropdown nowrap" style="float:right;">
          <button class="dropdown-button" @click="dropdownlist=true">
            <awesomeIcon icon="eye"/> {{intakeBrand == 'All' ? 'Alle merken' : intakeBrand}}
          </button>
          <div class="dropdown-bg" v-if="dropdownlist" @click="dropdownlist=false"></div>
          <ul class="dropdown-list" v-if="dropdownlist">
            <li
              v-for="brand in intakeBrands" :key="brand"
              @click="dropdownlist=false;intakeBrand=brand;"
            >
              {{brand == 'All' ? 'Alle merken' : brand}}
            </li>
            <li class="dropdown-cancel" @click="dropdownlist=false">Annuleren</li>
          </ul>
        </div>
        <button
          style="float:right;"  @click="mutations=!mutations"
        >{{mutations ? 'Ook met mutaties' : 'Zonder mutaties'}}</button>
      </div>

      <div class="card">
        <table width=100%>
          <thead class="table-legend">
            <tr>
              <th>#</th>
              <th>Merk</th>
              <th>Delta</th>
              <th>Waarde start</th>
              <th>Waarde nu</th>
              <th>Stortingen</th>
              <th>Onttrekkingen</th>
              <th>Laagste delta</th>
              <th v-if="search=='notice'">
                <button
                  @click="setChecks = !setChecks"
                  class="secondary"
                  style="float:left;padding:0;">
                  <awesomeIcon :icon="setChecks ? 'check-square' : 'fa-regular fa-square'"/>
                </button>
              </th>
            </tr>
          </thead>
          <tr
            v-for="(profile) in slice(
              filter(
                filter(
                  filter(profiles, mutationsFilter), brandFilter
                ), searchFilter
              ), currentPage * resultsPerPage,
              (currentPage + 1) * resultsPerPage
            )"
            :key="`s${profile.port}`"
          >
            <td width=50>{{profile.port}}</td>
            <td width=50>{{profile.brand}}</td>
            <td v-if="profile.delta!==null">{{formatPrice(Number(profile.delta))}}%</td>
            <td v-else>?</td>
            <td>{{formatPrice(Number(profile.period_value))}}</td>
            <td>{{formatPrice(Number(profile.port_value))}}</td>
            <td>{{formatPrice(Number(profile.period_deposited))}}</td>
            <td>{{formatPrice(Number(profile.period_withdrawn))}}</td>
            <td>
              {{formatPrice(Number(profile.alert), true)}}%
              <button
                style="float:right;"
                @click="sendPortLoss(profile.port)"
                v-if="Math.ceil(
                  Number(profile.delta) / 10) < 0
                  && Math.ceil(Number(profile.delta) / 10) < Math.ceil(Number(profile.alert) / 10)">
                Verstuur melding
              </button>
            </td>
            <td v-if="search=='notice'">
              <button
                @click="checks[profile.port] = !checks[profile.port]"
                class="secondary"
                style="float:left;padding:0;"
              >
                <awesomeIcon
                  :icon="checks[profile.port] ? 'check-square' : 'fa-regular fa-square'"
                />
              </button>
            </td>
          </tr>
          <tr v-if="search=='notice' && filter(checks).length > 0">
            <td colspan=6>&nbsp;</td>
            <td colspan=2>
              <button @click="sendSelected">Verstuur naar selectie</button>
            </td>
          </tr>
        </table>
        <pagerElement
          v-model="currentPage"
          :records="
            filter(
              filter(
                filter(profiles,mutationsFilter),
                brandFilter,
              ),
              searchFilter,
            ).length
          "
          :resultsPerPage="resultsPerPage"
        />
      </div>
    </template>
    <div v-else class="loader" />
  </div>
</template>

<script>
import {
  sumBy, sortBy, filter, slice,
} from 'lodash-es';

export default {
  name: 'AdminDeltas',
  data() {
    return {
      search: 'notice',
      status: [],
      profiles: null,
      currentPage: 0,
      resultsPerPage: 10,
      checks: {},
      setChecks: false,
      busy: false,
      dropdownlist: false,
      mutations: true,
      intakeBrand: 'All',
      intakeBrands: [
        'All',
        'Onbekend',
        'Doelbeleggen',
        'OXBY',
        'VMVB',
        'BVS',
      ],
    };
  },
  created() {
    this.getProfiles();
  },
  watch: {
    setChecks() {
      const ports = filter(
        filter(
          filter(
            this.profiles,
            this.brandFilter,
          ),
          this.mutationsFilter,
        ),
        this.searchFilter,
      );
      for (let i = 0; i < ports.length; i += 1) {
        this.checks[ports[i].port] = this.setChecks;
      }
    },
  },
  computed: {
    brandFilter() {
      if (this.intakeBrand !== 'All') {
        return { brand: this.intakeBrand };
      }
      return null;
    },
    mutationsFilter() {
      if (!this.mutations) {
        return { period_deposited: null, period_withdrawn: null };
      }
      return null;
    },
  },
  methods: {
    filter,
    slice,
    sumBy,
    sendSelected() {
      this.busy = true;
      if (Object.entries(this.checks).length > 0) {
        const port = Object.entries(this.checks)[0][0];
        if (this.checks[port]) {
          delete this.checks[port];
          this.sdk.sendPortLoss(port, this.sendSelected);
        } else {
          delete this.checks[port];
          this.sendSelected();
        }
      } else {
        this.getProfiles();
        this.busy = false;
      }
    },
    updateSearch() {
      this.currentPage = 0;
      this.resultsPerPage = 10;
      this.search = this.$refs.search.value.toLowerCase().trim();
    },
    searchFilter(obj) {
      if (
        this.search === 'queued'
        && obj.delta === null
      ) {
        return true;
      }
      if (
        this.search === 'notice'
        && obj.delta <= -10
        && Math.floor(-Number(obj.alert) / 10) < Math.floor(-Number(obj.delta) / 10)
      ) {
        return true;
      }
      if (
        this.search === 'negative'
        && obj.delta < 0
      ) {
        return true;
      }
      if (obj.port.toLowerCase().indexOf(this.search) > -1) {
        return true;
      }
      return false;
    },
    getProfiles() {
      this.profiles = null;
      this.sdk.getStatus((statusResponse) => {
        if (statusResponse.status === 200) {
          this.status = statusResponse.data;
          this.sdk.getAdminPortloss((response) => {
            if (response.status === 200) {
              const profilesArray = [];
              for (let i = 0; i < response.data.length; i += 1) {
                if (response.data[i].port_value > 0) {
                  profilesArray.push(response.data[i]);
                }
              }
              this.profiles = sortBy(
                profilesArray,
                'delta',
              );
              this.$nextTick(() => {
                this.resultsPerPage = 20;
              });
            } else {
              this.sdk.logout();
              window.location.reload();
            }
          });
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },

    sendPortLoss(port) {
      this.sdk.sendPortLoss(port, this.getProfiles);
    },
  },
};
</script>
